import * as React from 'react';
import classNames from 'classnames';
import { Icon } from '@ridi/rsg';

interface NoticeSelectProps {
  haveRidiSelectBookInSetBooks: boolean;
  setBookElementId: string;
  isRidiSelectBook: boolean;
  ridiSelectDetailUrl: string; 
}

export const NoticeSelect: React.FC<NoticeSelectProps> = props => {
  const {haveRidiSelectBookInSetBooks, setBookElementId, isRidiSelectBook, ridiSelectDetailUrl} = props;
  const infoTitle = haveRidiSelectBookInSetBooks
    ? '리디셀렉트에서 볼 수 있는 책이 포함되어 있습니다.'
    : isRidiSelectBook
      ? '리디셀렉트에서 바로 볼 수 있는 책입니다!'
      : '';
  const anchorHref = haveRidiSelectBookInSetBooks ? `#${setBookElementId}` : isRidiSelectBook ? ridiSelectDetailUrl : null;

  if(!haveRidiSelectBookInSetBooks && !isRidiSelectBook) return null;

  return (
    <div className="BookDetailNotice_List">
      <div className={classNames(
        'BookDetailNotice_List_Header',
        'BookDetailNotice_List_Header-select'
      )}>
        셀렉트
      </div>
      <div className="BookDetailNotice_List_Group">
        <div className="BookDetailNotice_List_Item BookDetailNotice_List_Item-event">
          <a className="BookDetailNotice_Select_Link" href={anchorHref}>
            <div className="BookDetailNotice_List_Item_Title">{infoTitle}</div>
            <Icon className="BookDetailNotice_List_Item_ArrowIcon" name="arrow_2_right" />
          </a>
        </div>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./pages/bookDetail/components/Notice/NoticeSelect.tsx